<template>
  <div>
    <v-row>
      <v-col cols="12" md="6" >
        <v-radio-group v-model="value.tipo" row 
        dense
          :rules="[
                  this.$validators.string.required,
            ]">
          <v-radio
            label="Sintético"
            value="S"
          ></v-radio>
          <v-radio
            label="Analítico"
            value="A"
          ></v-radio>
        </v-radio-group>
      </v-col> 
      <v-col cols="12" md="12">
        <search-box 
            label="Fornecedor"
            popup-label="Selecione um Fornecedor"
            :id.sync="value.idFornecedor"
            :nomeCompletoSemCnpj.sync="value.nomeCompletoFornecedorSemCnpj"
            :hidden-clear="false"
            :value="fornecedor"
            :loader-fn="loadeFornecedor"
            item-key="id"
            item-text="nomeCompletoSemCnpj">
          <template v-slot:empty>
            <p class="ma-2">
              Nenhum Fornecedor encontrado
            </p>
          </template>
        </search-box>
      </v-col>
      <v-col cols="12" md="12">
        <search-box
            label="Comprador"
            popup-label="Selecione um Comprador"
            :id.sync="value.idComprador"
            :nomeCompleto.sync="value.descricaoComprador"
            :hidden-clear="false"
            :value="comprador"
            :loader-fn="loadeComprador"
            item-key="id"
            item-text="nomeCompleto">
          <template v-slot:empty>
            <p class="ma-2">
              Nenhum Comprador encontrado
            </p>
          </template>
        </search-box>
      </v-col>
      <v-col cols="12" sm="12">Período do Match</v-col>
      <v-col cols="12" sm="6">
        <v-text-field label="* Data Inicio"
            dense
            type="date"
            v-model="value.dtInicio"
            :rules="[
                this.$validators.string.required,
                v => this.$validators.string.lessThanOrEquals(v, 10)
            ]"/>
      </v-col>
      <v-col cols="12" sm="6">
        <v-text-field label="* Data Fim"
              dense
              type="date"
              v-model="value.dtFim"
              :rules="[
                  this.$validators.string.required,
                  v => this.$validators.string.lessThanOrEquals(v, 10)
              ]"/>
      </v-col>  
    </v-row>
  </div>
</template>

<script>

import {ItemDeDominio} from "../../../../api/itemsDominio";
import LookupDominio from "../../common/LookupDominio";
import OrderInput from "../../common/OrderInput";
import SearchBox from "../../common/SearchBox";
//PKs
import {findAll as findAllFornecedor} from "@/api/fornecedor";
import {findAll as findAllComprador} from "@/api/comprador";

export default {
  name: "RelatorioMatchForm",
  components: {
    SearchBox,
    LookupDominio,
    OrderInput
  },
  props: {
    value: {
      type: Object,
    },
  },
  data() {
    return {
      lookups: {
        estado: ItemDeDominio.COMBO_ESTADO, 
        status: ItemDeDominio.STATUS_PADRAO,
      },
    }
  },
  watch: {
  },
  computed: {
    fornecedor(){
      if (this.value.idFornecedor == null) return null;
      return {
        id: this.value.idFornecedor,
        nomeCompletoSemCnpj: this.value.nomeCompletoFornecedorSemCnpj,
      }      
    },
    comprador(){
      if (this.value.idComprador == null) return null;
      return {
        id: this.value.idComprador,
        nomeCompleto: this.value.descricaoComprador
      }      
    },
  },
  methods: {
    loadeFornecedor(page, search) {
      return findAllFornecedor(page, {
        nome: search,
      })
    },
    loadeComprador(page, search) {
      return findAllComprador(page, {
        nome: search
      })
    },
  }
}
</script>

<style scoped lang="scss">

</style>